import HighlightAltIcon from "@mui/icons-material/HighlightAlt"
import HighlightAltOutlinedIcon from "@mui/icons-material/HighlightAltOutlined"
import { Box, IconButton, Tooltip } from "@mui/material"
import { extraColors } from "../../utils/theme"

interface LassoSelectToggleProps {
  isSelecting: boolean
  onToggle: () => void
  drawerOpen: boolean
  drawerWidth: number
}

export const LassoSelectToggle = ({
  isSelecting,
  onToggle,
  drawerOpen,
  drawerWidth,
}: LassoSelectToggleProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 56,
        right: drawerOpen ? drawerWidth + 12 : 12,
        zIndex: 1,
        transition: theme =>
          theme.transitions.create("right", {
            duration: theme.transitions.duration.enteringScreen,
          }),
      }}
    >
      <Tooltip
        title={isSelecting ? "Exit selection mode" : "Lasso select"}
        placement="left"
        disableInteractive
      >
        <IconButton
          onClick={onToggle}
          aria-label={isSelecting ? "Exit selection mode" : "Lasso select"}
          sx={{
            bgcolor: isSelecting
              ? extraColors.status.navyLight
              : extraColors.dark5,
            color: isSelecting ? extraColors.dark : extraColors.white,
            "&:hover": {
              bgcolor: isSelecting
                ? extraColors.status.navyLight
                : extraColors.dark10,
            },
            boxShadow: 2,
          }}
        >
          {isSelecting ? <HighlightAltIcon /> : <HighlightAltOutlinedIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
